import axios from 'axios';
import EndPointInfo from '../utility/Endpoints';
import updateContactAttributes from './contactAttributesService';

const { chatDataEndpoint } = EndPointInfo;

const storeCCDetails = async (initialContactId, customerStripeID) => {
  await updateContactAttributes(initialContactId, { paymentCustomerId: customerStripeID });
  const response = await axios.post(
    chatDataEndpoint,
    {
      method: 'storeStripeCCDetails',
      data: {
        initialContactId,
        customerStripeID,
      },
    },
    {
      headers: {
        'X-API-Key': process.env.REACT_APP_API_GATEWAY_API_KEY_CHAT,
      },
    }
  );
  return response.data;
};

export default storeCCDetails;
